import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Button, Text, Heading, Stack } from '@guestyci/arc';
import { StepActions } from '../../layout';

const QrCodeStep = ({ qrCodeSrc, onCantScan, onNext, onPickDifferentMethod, isSubmitting }) => {
  return (
    <Stack spacing={6} justify="between" className="gst-w-full gst-flex-1">
      <Stack spacing={6}>
        <Stack spacing={4}>
          <Heading variant="h2">{t('Set up Google Authenticator')}</Heading>
          <Text size="sm">
            {t('Launch Google Authenticator, tap the "+" icon, then select "Scan barcode".')}
          </Text>
        </Stack>

        <Stack spacing={4}>
          {qrCodeSrc ? (
            <img
              src={qrCodeSrc}
              alt={t('QR code for Google Authenticator setup')}
              className="gst-w-32 gst-h-32"
            />
          ) : (
            <div className="gst-w-32 gst-h-32 gst-bg-muted gst-rounded gst-animate-pulse" />
          )}

          <Button
            variant="plain"
            className="gst-w-fit gst-p-0"
            onClick={onCantScan}
          >
            {t("Can't scan?")}
          </Button>
        </Stack>
      </Stack>

      <StepActions
        onPrimaryClick={onNext}
        onSecondaryClick={onPickDifferentMethod}
        isSubmitting={isSubmitting}
      />
    </Stack>
  );
};

export default QrCodeStep;
